import 'core-js/features/string/includes'

if (!window.location.origin) {
  const { protocol, hostname, port } = window.location
  window.location.origin = `${protocol}//${hostname}${port ? `:${port}` : ''}`
}
